import { ShieldCheck, Award } from "lucide-react";

const PARTNERS = [
  {
    name: "Amazon",
    title: "SPN Verified",
    color: "#FF9900",
    icon: Award,
    desc: "Amazon Service Provider Network — verified onboarding & growth partner.",
  },
  {
    name: "JioMart",
    title: "Verified Partner",
    color: "#008ECC",
    icon: ShieldCheck,
    desc: "Reliance Retail / JioMart certified seller onboarding partner.",
  },
];

export default function AuthorizedPartners() {
  return (
    <section
      data-testid="authorized-partners"
      className="border-y-2 border-black bg-white py-16 md:py-20"
    >
      <div className="mx-auto max-w-7xl px-4 md:px-8">
        <div className="text-center">
          <div className="eyebrow">Trust & Authorization</div>
          <h2 className="display mt-3 text-3xl font-black tracking-tight md:text-4xl">
            Officially recognised by India's biggest marketplaces.
          </h2>
        </div>
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {PARTNERS.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.name}
                data-testid={`partner-${p.name.toLowerCase()}`}
                className="card-brutal flex items-center gap-6 p-6 md:p-8"
              >
                <div
                  className="flex h-20 w-20 shrink-0 items-center justify-center border-2 border-black"
                  style={{ background: p.color, color: "#fff" }}
                >
                  <Icon size={36} strokeWidth={1.5} />
                </div>
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-black/60">
                    {p.title}
                  </div>
                  <div className="display mt-1 text-2xl font-black tracking-tight md:text-3xl">
                    {p.name}
                  </div>
                  <p className="mt-1 text-sm text-black/70">{p.desc}</p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
